import React, { useEffect, useState } from "react"
import { store } from "../../../../store/favor/store"
import { getQuoteList, getQuoteList_post } from "../../../../modules/quote/web"
import { Observer } from "mobx-react-lite"
import { toJS } from "mobx"
import { LoadStatus } from "../../../shared/load_status/index"
import { formatColor, formatNumToFixed, formatNumToPercent } from "../../../shared/utils"

export function StockList() {
  const [pageParam, setPageParam] = useState({
    dataSize: 0,
    totalSize: 0,
    maxPageNumber: 0,
  })
  const [isValidating, setIsValidating] = useState(false)

  useEffect(() => {
    // let flag = false // 由于async，防止内存泄漏
    setIsValidating(true)
    ;(async () => {
      if (store.delayFlag) {
        const quoteList = await getQuoteList_post(store.param, toJS(store.stockCodes))
        if (quoteList) {
          setPageParam({
            dataSize: store.param.psize,
            totalSize: quoteList.total,
            maxPageNumber: Math.ceil(quoteList.total / store.param.psize),
          })
          store.setCurrentFavorList(quoteList.data.splice(0, store.param.psize))
          store.setFavorList(quoteList.data)
          setIsValidating(false)
        }
      }
    })()
    return () => {
      // flag = true
    }
  }, [store.stockCodes])

  useEffect(() => {
    const refreshData = () => {
      store.timer && clearInterval(store.timer)
      return setInterval(async () => {
        let param = toJS(store.param)
        param.psize = (param.pindex <= 1 ? 1 : param.pindex) * param.psize
        param.pindex = 1
        const quoteList = await getQuoteList_post(param, store.stockCodes)

        if (quoteList) {
          store.setCurrentFavorList(quoteList.data.splice(0, param.psize))
          setPageParam({
            dataSize: store.param.pindex * store.param.psize,
            totalSize: quoteList.total,
            maxPageNumber: Math.ceil(quoteList.total / store.param.psize),
          })
        }
      }, 30 * 1000)
    }

    window.onscroll = function () {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop //滚动条距离顶部
      const scrollHeight = document.documentElement.scrollHeight //滚动条内容的总高度
      if (scrollHeight - scrollTop - window.innerHeight < 6) {
        setIsValidating(true)
      }

      if (scrollTop + window.innerHeight + 1 > scrollHeight && store.param.pindex < pageParam.maxPageNumber) {
        let timer: any = null
        if (!timer) {
          timer = setTimeout(async () => {
            let param = toJS(store.param)
            param.pindex += 1
            store.setParam({ ...param })

            let previousData = toJS(store.currentFavorList)
            let tempFavorList = toJS(store.favorList)

            let nextPageResult = tempFavorList.splice(0, store.param.psize)
            const newData = previousData.concat(nextPageResult)

            store.setFavorList(tempFavorList)
            store.setCurrentFavorList(newData)
            setPageParam({ ...pageParam, dataSize: store.currentFavorList.length })
            timer = null
          }, 400)
        }
      }
      if (pageParam.totalSize <= pageParam.dataSize) {
        setIsValidating(false)
      }
    }

    store.setTimer(refreshData())

    return () => {
      store.timer && clearInterval(toJS(store.timer))
      window.onscroll = null
    }
  })

  return (
    <Observer>
      {() => (
        <>
          <>
            {toJS(store.currentFavorList).length ? (
              toJS(store.currentFavorList).map((item: any) => {
                return (
                  <dd key={item.market + "." + item.code}>
                    <a href={`//wap.eastmoney.com/quote/stock/${item.market}.${item.code}.html`}>
                      <div>
                        <p>{item.name}</p>
                        <p>{item.code}</p>
                      </div>
                      {/* {isTips(item.market, item.f19) ? (
                        <>
                          <div className={formatTipsSingleColor(item.zde)}>{formatNumToFixed(item.new_price, item.f1)}</div>
                          <div className={formatTipsSingleColor(item.zde)}>{formatNumToPercent(item.zdf, item.f152)}</div>
                        </>
                      ) : ( */}
                      <>
                        <div className={formatColor(item.zde)}>{formatNumToFixed(item.new_price, item.f1)}</div>
                        <div className={formatColor(item.zde)}>{formatNumToPercent(item.zdf, item.f152)}</div>
                      </>
                      {/* )} */}
                    </a>
                  </dd>
                )
              })
            ) : (
              <LoadStatus icon={false} title={"暂无该自选股票"} className={"com_tips"} />
            )}
            {pageParam.totalSize > pageParam.dataSize ? !isValidating && <div className="comm-more"></div> : pageParam.totalSize > 0 && <LoadStatus icon={false} title={"已全部加载"} className={"comm-more gray"} />}
          </>
          {pageParam.totalSize > 0 && isValidating && <LoadStatus icon={true} title={"数据加载中..."} className={"com_tips"} />}
        </>
      )}
    </Observer>
  )
}
